import * as React from 'react';

const SvgX = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="#56565b"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="x_svg__feather x_svg__feather-x"
    {...props}
  >
    <path d="M18 6L6 18M6 6l12 12" />
  </svg>
);

export default SvgX;
